import React from 'react';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const HideIcon = () => (
  <Icon tooltip="Hide" iconObj={faAngleUp} />
);

export default HideIcon;